import {useTranslations} from 'next-intl';
import Faq from '@/content/faq';
import {SectionSpacedTopLgToHeroPlus} from '@/section';
import {buildFaqQuestions} from 'helpers/workable-ai-faq';
import type {WorkableAiFaqItem} from '@/content/workable-ai/types';

const FaqSection = () => {
  const t = useTranslations('workableAi.faq');
  const faqItems = t.raw('items') as WorkableAiFaqItem[];
  const faqQuestions = buildFaqQuestions(faqItems);

  return (
    <SectionSpacedTopLgToHeroPlus>
      <Faq title={t('title')} questions={faqQuestions} variant="accordion" isSafe arrow />
    </SectionSpacedTopLgToHeroPlus>
  );
};

export default FaqSection;
